import React, { lazy, Suspense, useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Header.js";
import Footer from "../Home/components/Footer.js";
import SEO from "../Home/components/SEO.js";
import { resources } from "../Home/components/Resources.js";
import { getImageFromAssetFolder } from "../../utils/assets.js";

const ResourceModuleRenderer = () => {
  const { slug, folder } = useParams();

  const componentName = slug.toLowerCase();

  const ArticleModule = lazy(() =>
    import(`./${folder}/${componentName}.js`).catch(() =>
      import("./resources/404.js")
    )
  );

  const article = useMemo(() => {
    return resources.find((it) => it.slug == slug);
  }, [slug]);

  return (
    <>
      {article && (
        <SEO
          title={article?.title}
          description={article?.description}
          keywords={article?.keywords}
          slug={article?.slug}
          image={getImageFromAssetFolder(`${article?.slug}.png`, "thumbnails/")}
        />
      )}
      <Header home={false} />
      <Suspense fallback={<LoadingFallback />}>
        <ArticleModule />
        <Footer />
      </Suspense>
    </>
  );
};

const LoadingFallback = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="flex items-center space-x-3 text-lg font-medium text-gray-700">
        <svg
          className="animate-spin h-6 w-6 text-blue-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          ></path>
        </svg>
        <span>Loading content...</span>
      </div>
    </div>
  );
};

export default ResourceModuleRenderer;
